import axios from "axios";

class S3UploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append("media", file);

          axios
            .post(
              `${process.env.REACT_APP_API_URL}/api/message/upload-inline`,
              formData,
              { withCredentials: true }
            )
            .then((res) => {
              // Build the proxy URL that will redirect to a fresh signed S3 URL
              const proxyUrl = `${process.env.REACT_APP_API_URL}/api/message/inline-image?key=${encodeURIComponent(res.data.key)}`;
              resolve({ default: proxyUrl });
            })
            .catch((err) => {
              reject(err?.response?.data?.error || "Erreur d'upload");
            });
        })
    );
  }

  abort() {}
}

export function S3UploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new S3UploadAdapter(loader);
  };
}
